// filepath: /Users/pabloosio/Documents/GitHub/survey-cms/src/components/authentication/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { isTokenExpired } from '../../utils/auth'; // Asegúrate de que la ruta sea correcta
import PropTypes from 'prop-types';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('authToken'); // Verifica si el token existe

  if (!token || isTokenExpired(token)) {
    // Redirige al inicio de sesión si no hay token
    return <Navigate to="/authentication/card/login" replace />;
  }

  // Permite el acceso si hay token
  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node
};

export default ProtectedRoute;
